import React, { useState, useEffect, useCallback } from "react";
import {
  Modal,
  Form,
  Tooltip,
  OverlayTrigger,
  Toast,
  ToastContainer,
} from "react-bootstrap";
import "./EditFieldModal.css";
import { SubHeading } from "../../../../Global/GlobalText";
import {
  InputLabel,
  InputType,
  SelectBorder,
} from "../../../../Global/GlobalFormElement";
import {
  GreyBorderButton,
  RedBackgroundButton,
} from "../../../../Global/GlobalButton";
import { RiDeleteBin4Fill } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import { setEntryFieldPayload } from "../../../../Redux/Users/EntryFieldAction";
import {
  REMOVE_ENTRY_FORM_ID,
  resetEntryState,
  updateEntryFieldPayload,
} from "../../../../Redux/Users/action";
import { FaPlus } from "react-icons/fa";
import { toast } from "react-toastify";

const EditFieldModal = ({
  fieldType,
  field,
  onSave,
  onClose,
  fieldLabels,
  formData,
  setFormData,
  dataNames,
  formSchema,
  addedFields,
  updateAddedField,
}) => {
  const [selectedFieldLabel, setSelectedFieldLabel] = useState(field.label);
  const [selectedDataName, setSelectedDataName] = useState(field.dataName);
  const [newSelectedFieldLabel, setNewSelectedFieldLabel] = useState("");
  const [newSelectedDataName, setNewSelectedDataName] = useState("");
  const [isFieldSettings, setIsFieldSettings] = useState(true);
  const [addedSubfields, setAddedSubfields] = useState(
    field.addedSubfields || []
  );
  const [showInfoToast, setShowInfoToast] = useState(false);
  const [infoToastMessage, setInfoToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);
  const [errorToastMessage, setErrorToastMessage] = useState("");

  const entryFieldPayload = useSelector((state) => state.entry.fieldPayload);
  const handleToggleSettings = () => {
    setIsFieldSettings(!isFieldSettings);
  };

  const [updatedField, setUpdatedField] = useState({
    ...field,
    options: field.options || [],
    includeOther: field.includeOther || false,
    dataName: field.dataName || `field_${Date.now()}`,
    updaTEDATANEM: dataNames,
  });
  const dispatch = useDispatch();

  const fileTypes = [
    ".jpg",
    ".zip",
    ".png",
    ".jpeg",
    ".tif",
    ".wmf",
    ".eps",
    ".bmp",
    ".tiff",
    ".gif",
    ".pdf",
    ".doc",
    ".rtf",
    ".pptx",
    ".xls",
    ".ppt",
    ".docx",
    ".xlsx",
    ".txt",
  ];

  const [errors, setErrors] = useState({});

  console.log(formSchema, "fomrsdaddasdasdadsadas");
const [conditions, setConditions] = useState({
    isRequiredChecked: field.isRequired ?? true,
    isRequiredIf: field.isRequiredIf || false,
    requiredFieldValue: field.requiredFieldValue
      ? [field.requiredFieldValue]
      : [],
    requiredCondition: field.requiredCondition ? [field.requiredCondition] : [],
    requiredConditionValue: field.requiredConditionValue
      ? [field.requiredConditionValue]
      : [],
    isVisibleChecked: field.visible ?? true,
    isVisibleIfChecked: field.isVisibleIf || false,
    visibleFieldValue: field.visibleFieldValue ? [field.visibleFieldValue] : [],
    visibleCondition: field.visibleCondition
      ? [field.visibleCondition]
      : ["Equals (Default)"],
    visibleConditionValue: field.visibleConditionValue
      ? [field.visibleConditionValue]
      : [],
    toselectedDataName: field.dataName,
    toselectedlabel: field.label,
    // FIXED: Use nullish coalescing (??) instead of OR (||)
    isVisibleCheckedInJudging: field.isVisibleCheckedInJudging ?? true,
    isVisibleIfCheckedInJudging: field.isVisibleIfCheckedInJudging ?? false,
    // FIXED: Ensure arrays are properly handled
    visibleInJudgingFieldValue: Array.isArray(field.visibleInJudgingFieldValue) 
      ? field.visibleInJudgingFieldValue 
      : (field.visibleInJudgingFieldValue ? [field.visibleInJudgingFieldValue] : []),
    visibleInJudgingCondition: Array.isArray(field.visibleInJudgingCondition)
      ? field.visibleInJudgingCondition
      : (field.visibleInJudgingCondition ? [field.visibleInJudgingCondition] : ["Equals"]),
    visibleInJudgingInConditionValue: Array.isArray(field.visibleInJudgingInConditionValue)
      ? field.visibleInJudgingInConditionValue
      : (field.visibleInJudgingInConditionValue ? [field.visibleInJudgingInConditionValue] : []),
    selectedLabelPosition: field.selectedLabelPosition
      ? field.selectedLabelPosition
      : "top",
    selectedFieldSize: field.selectedFieldSize
      ? field.selectedFieldSize
      : "100%",
    uploadFileSize: field.uploadFileSize ? field.uploadFileSize : "",
    uploadFileType: field.uploadFileType || [],
    requiredCriteriaPattern: field.requiredCriteriaPattern
      ? field.requiredCriteriaPattern
      : "",
    visibleCriteriaPattern: field.visibleCriteriaPattern
      ? field.visibleCriteriaPattern
      : "",
    visibleInJudgingCriteriaPattern: field.visibleInJudgingCriteriaPattern
      ? field.visibleInJudgingCriteriaPattern
      : "",
  });

  console.log(conditions.isVisibleCheckedInJudging, "12asdasdasd3");

  console.log(field, "12312312312312321");

  const isAddedField = fieldType === "added";

  useEffect(() => {
    const fieldToEdit = entryFieldPayload.find(
      (item) => item.dataName === field.dataName
    );

    if (fieldToEdit) {
      setUpdatedField({
        ...fieldToEdit,
        options: fieldToEdit.options || [],
        includeOther: fieldToEdit.includeOther || false,
      });

      setConditions({
        isRequiredChecked: fieldToEdit.required ?? true,
        isRequiredIf: fieldToEdit.isRequiredIf || false,
        requiredFieldValue: fieldToEdit.requiredFieldValue
          ? [...fieldToEdit.requiredFieldValue]
          : [],
        requiredCondition: fieldToEdit.requiredCondition
          ? [...fieldToEdit.requiredCondition]
          : [],
        requiredConditionValue: fieldToEdit.requiredConditionValue
          ? [...fieldToEdit.requiredConditionValue]
          : [],
        isVisibleChecked: fieldToEdit.visible ?? true,
        isVisibleIfChecked: fieldToEdit.isVisibleIf || false,
        visibleFieldValue: fieldToEdit.visibleFieldValue
          ? [...fieldToEdit.visibleFieldValue]
          : [],
        visibleCondition: fieldToEdit.visibleCondition
          ? [...fieldToEdit.visibleCondition]
          : [],
        visibleConditionValue: fieldToEdit.visibleConditionValue
          ? [...fieldToEdit.visibleConditionValue]
          : [],
        updaTEDATANEM: dataNames,
        selectedLabelPosition: fieldToEdit.selectedLabelPosition
          ? fieldToEdit.selectedLabelPosition
          : "top",
        selectedFieldSize: fieldToEdit.selectedFieldSize
          ? fieldToEdit.selectedFieldSize
          : "100%",
        uploadFileSize: fieldToEdit.uploadFileSize
          ? fieldToEdit.uploadFileSize
          : "",
        uploadFileType: fieldToEdit.uploadFileType || [],
        isVisibleCheckedInJudging:
          fieldToEdit.isVisibleCheckedInJudging ?? true,
        isVisibleIfCheckedInJudging:
          fieldToEdit.isVisibleIfCheckedInJudging ?? false,
        visibleInJudgingFieldValue: fieldToEdit.visibleInJudgingFieldValue
          ? [...fieldToEdit.visibleInJudgingFieldValue]
          : [],
        visibleInJudgingCondition: fieldToEdit.visibleInJudgingCondition
          ? [...fieldToEdit.visibleInJudgingCondition]
          : [],
        visibleInJudgingInConditionValue:
          fieldToEdit.visibleInJudgingInConditionValue
            ? [...fieldToEdit.visibleInJudgingInConditionValue]
            : [],
        requiredCriteriaPattern: fieldToEdit.requiredCriteriaPattern
          ? fieldToEdit.requiredCriteriaPattern
          : "",
        visibleCriteriaPattern: fieldToEdit.visibleCriteriaPattern
          ? fieldToEdit.visibleCriteriaPattern
          : "",
        visibleInJudgingCriteriaPattern:
          fieldToEdit.visibleInJudgingCriteriaPattern
            ? fieldToEdit.visibleInJudgingCriteriaPattern
            : "",
      });

      setSelectedFieldLabel(fieldToEdit.label);
      setSelectedDataName(fieldToEdit.dataName);
      setAddedSubfields(fieldToEdit.addedSubfields || []);
    } else {
      setConditions({
        isRequiredChecked: field.isRequired ?? true,
        isRequiredIf: field.isRequiredIf || false,
        requiredFieldValue: field.requiredFieldValue
          ? [...field.requiredFieldValue]
          : [],
        requiredCondition: field.requiredCondition
          ? [...field.requiredCondition]
          : [],
        requiredConditionValue: field.requiredConditionValue
          ? [...field.requiredConditionValue]
          : [],
        isVisibleChecked: field.visible ?? true,
        isVisibleIfChecked: field.isVisibleIf || false,
        visibleFieldValue: field.visibleFieldValue
          ? [...field.visibleFieldValue]
          : [],
        visibleCondition: field.visibleCondition
          ? [...field.visibleCondition]
          : [],
        visibleConditionValue: field.visibleConditionValue
          ? [...field.visibleConditionValue]
          : [],
        updaTEDATANEM: dataNames,
        selectedLabelPosition: field.selectedLabelPosition
          ? field.selectedLabelPosition
          : "top",
        selectedFieldSize: field.selectedFieldSize
          ? field.selectedFieldSize
          : "100%",
        uploadFileSize: field.uploadFileSize ? field.uploadFileSize : "",
        uploadFileType: field.uploadFileType || [],
        isVisibleCheckedInJudging: field.isVisibleCheckedInJudging ?? true,
        isVisibleIfCheckedInJudging: field.isVisibleIfCheckedInJudging ?? false,
        visibleInJudgingFieldValue: field.visibleInJudgingFieldValue
          ? [...field.visibleInJudgingFieldValue]
          : [],
        visibleInJudgingCondition: field.visibleInJudgingCondition
          ? [...field.visibleInJudgingCondition]
          : [],
        visibleInJudgingInConditionValue: field.visibleInJudgingInConditionValue
          ? [...field.visibleInJudgingInConditionValue]
          : [],
        requiredCriteriaPattern: field.requiredCriteriaPattern
          ? field.requiredCriteriaPattern
          : "",
        visibleCriteriaPattern: field.visibleCriteriaPattern
          ? field.visibleCriteriaPattern
          : "",
        visibleInJudgingCriteriaPattern: field.visibleInJudgingCriteriaPattern
          ? field.visibleInJudgingCriteriaPattern
          : "",
      });
    }

    setSelectedFieldLabel(field.label);
    setSelectedDataName(field.dataName);
    setAddedSubfields(field.addedSubfields || []);
  }, [field, entryFieldPayload]);

  const handleChange = useCallback((e) => {
    const { name, value, type, checked } = e.target;

    if (name === "labelPosition") {
      setConditions((prev) => ({
        ...prev,
        selectedLabelPosition: value,
      }));
    } else if (name === "fieldSize") {
      setConditions((prev) => ({
        ...prev,
        selectedFieldSize: value,
      }));
    } else if (name === "uploadFileSize") {
      setConditions((prev) => ({
        ...prev,
        uploadFileSize: value,
      }));
    } else {
      setUpdatedField((prev) => ({
        ...prev,
        [name]: type === "checkbox" ? checked : value,
      }));
    }
  }, []);

  const handleConditionChange = (e, index, fieldName) => {
    const { value } = e.target;

    setConditions((prev) => {
      const updatedValues = [...prev[fieldName]];

      if (!updatedValues[index] || updatedValues[index] === "") {
        updatedValues[index] = value;
      } else {
        updatedValues[index] = value;
      }

      return { ...prev, [fieldName]: updatedValues };
    });
  };

  const handleAddSubfield = () => {
    setAddedSubfields((prev) => [
      ...prev,
      { id: Date.now(), name: "", condition: "", value: "" },
    ]);
  };

  const handleSubfieldChange = (index, key, value) => {
    setAddedSubfields((prev) => {
      const updated = [...prev];
      updated[index][key] = value;
      return updated;
    });
  };

  const validatePattern = useCallback(
    (pattern, fieldCount, fieldName, skipToast = false) => {
      // Cache to track recent toasts to prevent duplicates
      const toastCache = new Map();

      const showToast = (key, type, message, options) => {
        if (
          !toastCache.has(key) ||
          Date.now() - toastCache.get(key) > options.autoClose
        ) {
          toastCache.set(key, Date.now());
          toast[type](message, options);
        }
      };

      if (!pattern) {
        if (!skipToast) {
          showToast(
            `${fieldName}_empty`,
            "info",
            `Pattern in ${fieldName} is empty. Use format like '1 AND 2' for ${fieldCount} fields.`,
            { position: "top-right", autoClose: 8000 }
          );
        }
        return true;
      }

      const parts = pattern.split(/\s+/).filter((part) => part.trim() !== "");

      const validNumbers = Array.from({ length: fieldCount }, (_, i) =>
        (i + 1).toString()
      );
      const validConjunctions = ["AND", "OR"];

      const hasAnd = parts.includes("AND");
      const hasOr = parts.includes("OR");
      if (hasAnd && hasOr) {
        if (!skipToast) {
          showToast(
            `${fieldName}_and_or`,
            "error",
            `Pattern in ${fieldName} cannot contain both AND and OR`,
            { position: "top-right", autoClose: 3000 }
          );
        }
        return false;
      }

      const numberParts = parts.filter((part, index) => index % 2 === 0);
      const uniqueNumbers = new Set(numberParts);
      if (uniqueNumbers.size !== numberParts.length) {
        if (!skipToast) {
          showToast(
            `${fieldName}_duplicate`,
            "error",
            `Duplicate numbers detected in ${fieldName} pattern. Each number must be unique.`,
            { position: "top-right", autoClose: 3000 }
          );
        }
        return false;
      }

      for (let i = 0; i < parts.length; i++) {
        if (i % 2 === 0) {
          if (!validNumbers.includes(parts[i])) {
            if (!skipToast) {
              showToast(
                `${fieldName}_invalid_number_${parts[i]}`,
                "error",
                `Invalid number in ${fieldName}: ${parts[i]}. Must be between 1 and ${fieldCount}`,
                { position: "top-right", autoClose: 3000 }
              );
            }
            return false;
          }
        } else {
          if (!validConjunctions.includes(parts[i])) {
            if (!skipToast) {
              showToast(
                `${fieldName}_invalid_conjunction_${parts[i]}`,
                "error",
                `Invalid conjunction in ${fieldName}: ${parts[i]}. Must be AND or OR`,
                { position: "top-right", autoClose: 3000 }
              );
            }
            return false;
          }
        }
      }

      if (parts.length % 2 === 0) {
        if (!skipToast) {
          showToast(
            `${fieldName}_invalid_format`,
            "error",
            `Invalid pattern format in ${fieldName}. Should alternate numbers and conjunctions`,
            { position: "top-right", autoClose: 3000 }
          );
        }
        return false;
      }

      return true;
    },
    []
  );

  const handleCriteriaPatternBlur = (fieldName, fieldCount) => {
    setShowErrorToast(false);
    setShowInfoToast(false);
    const pattern = conditions[fieldName];
    // Call validatePattern with skipToast set to true to avoid toasts on blur
    validatePattern(
      pattern,
      fieldCount,
      fieldName.replace("CriteriaPattern", ""),
      true
    );
  };

  const handleCriteriaPatternChange = (e, fieldName) => {
    const { value } = e.target;
    setConditions((prev) => ({
      ...prev,
      [fieldName]: value,
    }));
  };

  const handleConjunctionChange = (conjunction, section) => {
    setConditions((prev) => {
      let count, newPattern;
      if (section === "required") {
        count = prev.requiredFieldValue.length;
        if (count === 0) return prev;
        if (count === 1) return { ...prev, requiredCriteriaPattern: "1" };
        const numbers = Array.from({ length: count }, (_, i) => i + 1);
        newPattern = numbers.join(` ${conjunction} `);
        return { ...prev, requiredCriteriaPattern: newPattern };
      } else if (section === "visible") {
        count = prev.visibleFieldValue.length;
        if (count === 0) return prev;
        if (count === 1) return { ...prev, visibleCriteriaPattern: "1" };
        const numbers = Array.from({ length: count }, (_, i) => i + 1);
        newPattern = numbers.join(` ${conjunction} `);
        return { ...prev, visibleCriteriaPattern: newPattern };
      } else if (section === "visibleInJudging") {
        count = prev.visibleInJudgingFieldValue.length;
        if (count === 0) return prev;
        if (count === 1)
          return { ...prev, visibleInJudgingCriteriaPattern: "1" };
        const numbers = Array.from({ length: count }, (_, i) => i + 1);
        newPattern = numbers.join(` ${conjunction} `);
        return { ...prev, visibleInJudgingCriteriaPattern: newPattern };
      }
      return prev;
    });
  };

  const addRequiredConditionField = () => {
    setConditions((prev) => {
      const newIndex = prev.requiredFieldValue.length + 1;
      const newPattern =
        prev.requiredFieldValue.length === 0
          ? "1"
          : prev.requiredCriteriaPattern
          ? `${prev.requiredCriteriaPattern} AND ${newIndex}`
          : Array.from({ length: newIndex }, (_, i) => i + 1).join(" AND ");

      return {
        ...prev,
        requiredFieldValue: [...prev.requiredFieldValue, ""],
        requiredCondition: [...prev.requiredCondition, "Equals"],
        requiredConditionValue: [...prev.requiredConditionValue, ""],
        requiredCriteriaPattern: newPattern,
      };
    });
  };

  const addVisibleConditionField = () => {
    setConditions((prev) => {
      const newIndex = prev.visibleFieldValue.length + 1;
      const newPattern =
        prev.visibleFieldValue.length === 0
          ? "1"
          : prev.visibleCriteriaPattern
          ? `${prev.visibleCriteriaPattern} AND ${newIndex}`
          : Array.from({ length: newIndex }, (_, i) => i + 1).join(" AND ");

      return {
        ...prev,
        visibleFieldValue: [...prev.visibleFieldValue, ""],
        visibleCondition: [...prev.visibleCondition, "Equals"],
        visibleConditionValue: [...prev.visibleConditionValue, ""],
        visibleCriteriaPattern: newPattern,
      };
    });
  };

  const addVisibleInJudgingConditionField = () => {
    setConditions((prev) => {
      const newIndex = prev.visibleInJudgingFieldValue.length + 1;
      const newPattern =
        prev.visibleInJudgingFieldValue.length === 0
          ? "1"
          : prev.visibleInJudgingCriteriaPattern
          ? `${prev.visibleInJudgingCriteriaPattern} AND ${newIndex}`
          : Array.from({ length: newIndex }, (_, i) => i + 1).join(" AND ");

      return {
        ...prev,
        visibleInJudgingFieldValue: [...prev.visibleInJudgingFieldValue, ""],
        visibleInJudgingCondition: [
          ...prev.visibleInJudgingCondition,
          "Equals",
        ],
        visibleInJudgingInConditionValue: [
          ...prev.visibleInJudgingInConditionValue,
          "",
        ],
        visibleInJudgingCriteriaPattern: newPattern,
      };
    });
  };

  const removeConditionField = (index) => {
    setConditions((prev) => {
      const updatedFieldValues = prev.requiredFieldValue.filter(
        (_, i) => i !== index
      );
      const newPattern =
        updatedFieldValues.length === 0
          ? ""
          : Array.from(
              { length: updatedFieldValues.length },
              (_, i) => i + 1
            ).join(" AND ");

      return {
        ...prev,
        requiredFieldValue: updatedFieldValues,
        requiredCondition: prev.requiredCondition.filter((_, i) => i !== index),
        requiredConditionValue: prev.requiredConditionValue.filter(
          (_, i) => i !== index
        ),
        requiredCriteriaPattern: newPattern,
      };
    });
  };

  const removeVisibleConditionField = (index) => {
    setConditions((prev) => {
      const updatedFieldValues = prev.visibleFieldValue.filter(
        (_, i) => i !== index
      );
      const newPattern =
        updatedFieldValues.length === 0
          ? ""
          : Array.from(
              { length: updatedFieldValues.length },
              (_, i) => i + 1
            ).join(" AND ");

      return {
        ...prev,
        visibleFieldValue: updatedFieldValues,
        visibleCondition: prev.visibleCondition.filter((_, i) => i !== index),
        visibleConditionValue: prev.visibleConditionValue.filter(
          (_, i) => i !== index
        ),
        visibleCriteriaPattern: newPattern,
      };
    });
  };

  const removeVisibleConditionFieldInJudging = (index) => {
    setConditions((prev) => {
      const updatedFieldValues = prev.visibleInJudgingFieldValue.filter(
        (_, i) => i !== index
      );
      const newPattern =
        updatedFieldValues.length === 0
          ? ""
          : Array.from(
              { length: updatedFieldValues.length },
              (_, i) => i + 1
            ).join(" AND ");

      return {
        ...prev,
        visibleInJudgingFieldValue: updatedFieldValues,
        visibleInJudgingCondition: prev.visibleInJudgingCondition.filter(
          (_, i) => i !== index
        ),
        visibleInJudgingInConditionValue:
          prev.visibleInJudgingInConditionValue.filter((_, i) => i !== index),
        visibleInJudgingCriteriaPattern: newPattern,
      };
    });
  };
  const addValue = useCallback(() => {
    setUpdatedField((prev) => ({
      ...prev,
      options: [...prev.options, ""],
    }));
  }, []);

  const updateOption = (index, value) => {
    const options = [...updatedField.options];
    options[index] = value;
    setUpdatedField({ ...updatedField, options });
  };

  const removeOption = (index) => {
    const options = [...updatedField.options];
    options.splice(index, 1);
    setUpdatedField({ ...updatedField, options });
  };

  const handleMultiSelect = (e) => {
    const selectedValue = e.target.value;

    setConditions((prev) => {
      if (prev.uploadFileType.includes(selectedValue)) {
        return prev;
      }

      return {
        ...prev,
        uploadFileType: [...prev.uploadFileType, selectedValue],
      };
    });
  };

  const removeOptionDrop = (option) => {
    setConditions((prev) => ({
      ...prev,
      uploadFileType: prev.uploadFileType.filter((item) => item !== option),
    }));
  };

  const validateForm = useCallback(() => {
    const newErrors = {};

    if (!updatedField.dataName) newErrors.dataName = "Data name is required.";
    if (!updatedField.label) newErrors.label = "Label is required.";

    if (conditions.isRequiredChecked && conditions.isRequiredIf) {
      if (
        !validatePattern(
          conditions.requiredCriteriaPattern,
          conditions.requiredFieldValue.length,
          "Required"
        )
      ) {
        newErrors.requiredCriteriaPattern = "Invalid required criteria pattern";
      }
    }

    if (conditions.isVisibleChecked && conditions.isVisibleIfChecked) {
      if (
        !validatePattern(
          conditions.visibleCriteriaPattern,
          conditions.visibleFieldValue.length,
          "Visible"
        )
      ) {
        newErrors.visibleCriteriaPattern = "Invalid visible criteria pattern";
      }
    }

    if (
      conditions.isVisibleCheckedInJudging &&
      conditions.isVisibleIfCheckedInJudging
    ) {
      if (
        !validatePattern(
          conditions.visibleInJudgingCriteriaPattern,
          conditions.visibleInJudgingFieldValue.length,
          "Visible in Judging"
        )
      ) {
        newErrors.visibleInJudgingCriteriaPattern =
          "Invalid visible in judging criteria pattern";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  }, [updatedField, conditions]);

  const handleSave = useCallback(() => {
    if (!validateForm()) {
      console.log("Validation failed.");
      return;
    }

    if (!updatedField || !conditions) {
      console.error("Updated field or conditions are not defined.");
      return;
    }

    let updatedConditions = { ...conditions };

    if (!conditions.isRequiredIf) {
      updatedConditions = {
        ...updatedConditions,
        requiredFieldValue: "",
        requiredCondition: "",
        requiredConditionValue: "",
      };
    }

    if (!conditions.isVisibleIfChecked) {
      updatedConditions = {
        ...updatedConditions,
        visibleFieldValue: "",
        visibleCondition: "",
        visibleConditionValue: "",
      };
    }

    if (!conditions.isVisibleIfCheckedInJudging) {
      updatedConditions = {
        ...updatedConditions,
        visibleInJudgingFieldValue: "",
        visibleInJudgingCondition: "",
        visibleInJudgingInConditionValue: "",
      };
    }

    // const labelPosition = updatedField.options?.labelPosition || "";
    const entryFieldPayload = {
      type: updatedField.type,
      dataName: updatedField.dataName,
      addedSubfields,
      label: updatedField.label,
      hoverHint: updatedField.hoverHint || "",
      options: updatedField.options,
      required: updatedConditions.isRequiredChecked,
      includeOther: updatedField.includeOther,
      isRequiredIf: updatedConditions.isRequiredIf,
      requiredFieldValue: [...updatedConditions.requiredFieldValue],
      requiredCondition: [...updatedConditions.requiredCondition],
      requiredConditionValue: [...updatedConditions.requiredConditionValue],
      visible: updatedConditions.isVisibleChecked,
      isVisibleIf: updatedConditions.isVisibleIfChecked,
      visibleFieldValue: [...updatedConditions.visibleFieldValue],
      visibleCondition: [...updatedConditions.visibleCondition],
      visibleConditionValue: [...updatedConditions.visibleConditionValue],
      isVisibleCheckedInJudging: updatedConditions.isVisibleCheckedInJudging,
      isVisibleIfCheckedInJudging:
        updatedConditions.isVisibleIfCheckedInJudging,
      visibleInJudgingFieldValue: updatedConditions.visibleInJudgingFieldValue,
      visibleInJudgingCondition: updatedConditions.visibleInJudgingCondition,
      visibleInJudgingInConditionValue:
        updatedConditions.visibleInJudgingInConditionValue,
      renderlabel: selectedFieldLabel,
      renderDataName: selectedDataName,
      addedSubfields,
      selectedLabelPosition: updatedConditions.selectedLabelPosition,
      selectedFieldSize: updatedConditions.selectedFieldSize,
      uploadFileSize: updatedConditions.uploadFileSize || "",
      uploadFileType: updatedConditions.uploadFileType || [],
      requiredCriteriaPattern: updatedConditions.requiredCriteriaPattern || "",
      visibleCriteriaPattern: updatedConditions.visibleCriteriaPattern || "",
      visibleInJudgingCriteriaPattern:
        updatedConditions.visibleInJudgingCriteriaPattern || "",
    };

    console.log("Field Payload before save:", entryFieldPayload);

    try {
      dispatch(setEntryFieldPayload(entryFieldPayload));
      // dispatch(updateEntryFieldPayload(entryFieldPayload));
      // dispatch(resetEntryState());
      // dispatch({ type: REMOVE_ENTRY_FORM_ID, payload: "" });

      onSave(entryFieldPayload);
      onSave(updatedField);
      onClose();
    } catch (error) {
      console.error("Error during save operation:", error);
    }
  }, [
    validateForm,
    updatedField,
    conditions,
    newSelectedFieldLabel,
    selectedDataName,
    selectedFieldLabel,
    onSave,
    onClose,
    dispatch,
  ]);

  useEffect(() => {
    const fieldToEdit = entryFieldPayload.find(
      (item) => item.dataName === field.dataName
    );
    if (fieldToEdit) {
      setUpdatedField({
        ...fieldToEdit,
      });
    }
  }, [entryFieldPayload, field.dataName]);

  return (
    <Modal show={true} onHide={onClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Field Editor</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="registration_edit">
          <div className="registration_edit_heading">
            <SubHeading>
              Form Fields Editor:{" "}
              {updatedField.type.charAt(0).toUpperCase() +
                updatedField.type.slice(1)}
            </SubHeading>
          </div>

          <div className="toggle-buttons">
            <RedBackgroundButton
              onClick={handleToggleSettings}
              className={isFieldSettings ? "active" : ""}
            >
              Field Settings
            </RedBackgroundButton>
            {updatedField.label !== "Category" &&
              updatedField.label !== "Title of the Entry" && (
                <RedBackgroundButton
                  onClick={handleToggleSettings}
                  className={!isFieldSettings ? "active" : ""}
                >
                  Require/Visible
                </RedBackgroundButton>
              )}
          </div>
          {isFieldSettings ? (
            <form className="registration_edit_form">
              <div className="registration_edit_row">
                <InputLabel>Field Type</InputLabel>
                <InputType
                  type="text"
                  value={updatedField.type || ""}
                  disabled
                />
              </div>
              <div className="registration_edit_row">
                <InputLabel>Data Name</InputLabel>
                <InputType
                  type="text"
                  name="dataName"
                  value={updatedField.dataName || ""}
                  onChange={handleChange}
                  disabled
                />
                {errors.dataName && (
                  <div className="error">{errors.dataName}</div>
                )}
              </div>
            // Replace the Label input with textarea
<div className="registration_edit_row">
  <InputLabel>Label</InputLabel>
  <textarea
    name="label"
    className="form-control"
    rows="3"
    value={
      updatedField.label ||
      (entryFieldPayload &&
        entryFieldPayload.find(
          (item) => item.dataName === field.dataName
        )?.label) ||
      ""
    }
    onChange={handleChange}
    placeholder="Use HTML tags: <h1>, <p>, <strong>, <ul>, <li> etc."
    style={{ minHeight: "80px" }}
  />
  <small className="text-muted">
    Supported tags: &lt;h1&gt;, &lt;h2&gt;, &lt;h3&gt;, &lt;p&gt;, &lt;br&gt;, 
    &lt;strong&gt;, &lt;b&gt;, &lt;ul&gt;, &lt;li&gt;
  </small>
  {errors.label && <div className="error">{errors.label}</div>}
</div>
              <div className="registration_edit_row">
                <InputLabel>Hover Hint</InputLabel>
                <OverlayTrigger
                  placement="right"
                  overlay={
                    <Tooltip id="tooltip">{updatedField.hoverHint}</Tooltip>
                  }
                >
                  <InputType
                    type="text"
                    name="hoverHint"
                    value={updatedField.hoverHint || ""}
                    onChange={handleChange}
                    placeholder="Enter a hint for the side"
                  />
                </OverlayTrigger>
              </div>

              <div className="registration_edit_row">
                <InputLabel>Label Position</InputLabel>
                <div className="registration_edit_ckeck">
                  <Form.Check
                    type="radio"
                    label="Top"
                    name="labelPosition"
                    value="top"
                    checked={conditions.selectedLabelPosition === "top"}
                    onChange={handleChange}
                  />
                  <Form.Check
                    type="radio"
                    label="Left"
                    name="labelPosition"
                    value="left"
                    checked={conditions.selectedLabelPosition === "left"}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="registration_edit_row">
                <InputLabel>Field Size</InputLabel>
                <SelectBorder
                  as="select"
                  name="fieldSize"
                  value={conditions.selectedFieldSize || "100%"}
                  onChange={handleChange}
                >
                  <option value="50%">50%</option>
                  <option value="75%">75%</option>
                  <option value="100%">100%</option>
                  <option value="auto">Auto</option>
                </SelectBorder>
              </div>

              {(updatedField.type === "dropdown" ||
                updatedField.type === "radio" ||
                updatedField.type === "checkbox") && (
                <div>
                  <InputLabel>Options</InputLabel>
                  {updatedField.options.map((option, index) => (
                    <div key={index} className="registration_edit_option">
                      <InputType
                        type="text"
                        value={option}
                        onChange={(e) => updateOption(index, e.target.value)}
                      />
                      <RiDeleteBin4Fill
                        className="registration_edit_remove"
                        onClick={() => removeOption(index)}
                      />
                    </div>
                  ))}
                  <div
                    className="registration_edit_addoption"
                    onClick={addValue}
                  >
                    Add Option
                  </div>
                </div>
              )}

              {updatedField.type === "file" && (
                <div className="registration_edit_row">
                  <InputLabel>Enter File Size (MB)</InputLabel>
                  <InputType
                    type="text"
                    name="uploadFileSize"
                    value={
                      conditions.uploadFileSize ||
                      (entryFieldPayload &&
                        entryFieldPayload.find(
                          (item) => item.dataName === field.dataName
                        )?.uploadFileSize) ||
                      ""
                    }
                    onChange={handleChange}
                  />

                  <div className="registration_edit_row">
                    <InputLabel>Select File Types</InputLabel>
                    <SelectBorder
                      as="select"
                      name="uploadFileType"
                      value=""
                      onChange={handleMultiSelect}
                    >
                      <option value="" disabled>
                        Select file type
                      </option>
                      {fileTypes.map((type) => (
                        <option
                          key={type}
                          value={type}
                          style={{
                            backgroundColor: conditions.uploadFileType.includes(
                              type
                            )
                              ? "#d3d3d3"
                              : "white",
                          }}
                        >
                          {type}
                        </option>
                      ))}
                    </SelectBorder>
                    <div
                      style={{
                        marginTop: "10px",
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "8px",
                      }}
                    >
                      {conditions.uploadFileType.map((option) => (
                        <div
                          key={option}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            padding: "4px 8px",
                            borderRadius: "16px",
                            backgroundColor: "#e0e0e0",
                            fontSize: "12px",
                            color: "#333",
                          }}
                        >
                          {option}
                          <button
                            onClick={() => removeOptionDrop(option)}
                            style={{
                              marginLeft: "6px",
                              backgroundColor: "transparent",
                              border: "none",
                              cursor: "pointer",
                              color: "#888",
                              fontSize: "14px",
                              lineHeight: "1",
                              display: "flex",
                              alignItems: "center",
                            }}
                            title="Remove"
                          >
                            ✕
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}
            </form>
          ) : (
            <form className="registration_edit_form">
              {updatedField.label !== "Category" &&
                updatedField.label !== "Title of the Entry" && (
                  <>
                    {/* Required If Section */}
                    <div className="required-field">
                      <label>
                        <input
                          type="checkbox"
                          checked={conditions.isRequiredChecked}
                          onChange={() =>
                            setConditions((prev) => ({
                              ...prev,
                              isRequiredChecked: !prev.isRequiredChecked,
                            }))
                          }
                        />
                        Required
                      </label>
                      {conditions.isRequiredChecked && (
                        <div>
                          <label>
                            <input
                              type="checkbox"
                              checked={conditions.isRequiredIf}
                              name="isRequiredIf"
                              onChange={() =>
                                setConditions((prev) => {
                                  const isChecked = !prev.isRequiredIf;
                                  return {
                                    ...prev,
                                    isRequiredIf: isChecked,
                                    requiredFieldValue: isChecked ? [""] : [],
                                    requiredCondition: isChecked ? [""] : [],
                                    requiredConditionValue: isChecked
                                      ? [""]
                                      : [],
                                  };
                                })
                              }
                            />
                            Required if
                          </label>
                          {conditions.isRequiredIf && (
                            <>
                              {conditions.requiredFieldValue.map((_, index) => (
                                <div key={index} className="RegisterDiv">
                                  <div className="registration_edit_row">
                                    <InputLabel>Required Field</InputLabel>
                                    <SelectBorder
                                      value={
                                        conditions.requiredFieldValue[index]
                                      }
                                      onChange={(e) =>
                                        handleConditionChange(
                                          e,
                                          index,
                                          "requiredFieldValue"
                                        )
                                      }
                                    >
                                      <option value="">Select Field</option>
                                      {formSchema.map((item) => (
                                        <option
                                          key={item.dataName}
                                          value={item.label}
                                        >
                                          {item.label.length > 60
                                            ? `${item.label.slice(0, 150)}...`
                                            : item.label}
                                        </option>
                                      ))}
                                    </SelectBorder>
                                  </div>
                                  <div className="registration_edit_row">
                                    <InputLabel>Condition</InputLabel>
                                    <SelectBorder
                                      value={
                                        conditions.requiredCondition[index]
                                      }
                                      onChange={(e) =>
                                        handleConditionChange(
                                          e,
                                          index,
                                          "requiredCondition"
                                        )
                                      }
                                    >
                                      <option value="Equals ">
                                        Equals (Default)
                                      </option>
                                      <option value="contains">Contains</option>
                                      <option value="not-contains">
                                        Not Contains
                                      </option>
                                      <option value="startsWith">
                                        Starts With
                                      </option>
                                      <option value="not-startsWith">
                                        Not Starts With
                                      </option>
                                      <option value="endsWith">
                                        Ends With
                                      </option>
                                      <option value="not-endsWith">
                                        Not Ends With
                                      </option>
                                    </SelectBorder>
                                  </div>
                                  <div className="registration_edit_row">
                                    <InputLabel>Condition Value</InputLabel>
                                    <InputType
                                      type="text"
                                      value={
                                        conditions.requiredConditionValue[
                                          index
                                        ] || ""
                                      }
                                      onChange={(e) =>
                                        handleConditionChange(
                                          e,
                                          index,
                                          "requiredConditionValue"
                                        )
                                      }
                                    />
                                  </div>

                                  <div className="removeIcon">
                                    <RiDeleteBin4Fill
                                      className="remove-condition-icon"
                                      onClick={() =>
                                        removeConditionField(index)
                                      }
                                      style={{
                                        cursor: "pointer",
                                        color: "red",
                                        fontSize: "1.5em",
                                      }}
                                      title="Remove Condition"
                                    />
                                  </div>
                                </div>
                              ))}

                              <div className="registration_edit_row">
                                <InputLabel>Criteria Pattern</InputLabel>
                                <InputType
                                  type="text"
                                  value={conditions.requiredCriteriaPattern}
                                  onChange={(e) =>
                                    handleCriteriaPatternChange(
                                      e,
                                      "requiredCriteriaPattern"
                                    )
                                  }
                                  onBlur={() =>
                                    handleCriteriaPatternBlur(
                                      "requiredCriteriaPattern",
                                      conditions.requiredFieldValue.length
                                    )
                                  }
                                  placeholder="(1) AND (2)"
                                />
                                {errors.requiredCriteriaPattern && (
                                  <div className="error">
                                    {errors.requiredCriteriaPattern}
                                  </div>
                                )}
                                <div
                                  style={{
                                    marginTop: "0.5rem",
                                    display: "flex",
                                    gap: "0.5rem",
                                  }}
                                >
                                  <button
                                    type="button"
                                    className="conjunction-btn"
                                    onClick={() =>
                                      handleConjunctionChange("AND", "required")
                                    }
                                    style={{
                                      padding: "0.5rem 1rem",
                                      backgroundColor:
                                        conditions.requiredCriteriaPattern.includes(
                                          "AND"
                                        )
                                          ? "#d32f2f"
                                          : "#e0e0e0",
                                      color:
                                        conditions.requiredCriteriaPattern.includes(
                                          "AND"
                                        )
                                          ? "#fff"
                                          : "#333",
                                      border: "1px solid #ccc",
                                      borderRadius: "4px",
                                      cursor: "pointer",
                                    }}
                                  >
                                    AND
                                  </button>
                                  <button
                                    type="button"
                                    className="conjunction-btn"
                                    onClick={() =>
                                      handleConjunctionChange("OR", "required")
                                    }
                                    style={{
                                      padding: "0.5rem 1rem",
                                      backgroundColor:
                                        conditions.requiredCriteriaPattern.includes(
                                          "OR"
                                        )
                                          ? "#d32f2f"
                                          : "#e0e0e0",
                                      color:
                                        conditions.requiredCriteriaPattern.includes(
                                          "OR"
                                        )
                                          ? "#fff"
                                          : "#333",
                                      border: "1px solid #ccc",
                                      borderRadius: "4px",
                                      cursor: "pointer",
                                    }}
                                  >
                                    OR
                                  </button>
                                </div>
                              </div>
                              <button
                                type="button"
                                className="add-condition-btn"
                                onClick={addRequiredConditionField}
                                style={{ marginTop: "1rem" }}
                              >
                                <FaPlus className="plus-icon" /> Add Condition
                              </button>
                            </>
                          )}
                        </div>
                      )}
                    </div>

                    {/* Visible If Section */}
                    <div className="visible-field">
                      <label>
                        <input
                          type="checkbox"
                          checked={
                           conditions.isVisibleChecked
                          }
                          onChange={() =>
                            setConditions((prev) => ({
                              ...prev,
                              isVisibleChecked: !prev.isVisibleChecked,
                            }))
                          }
                        />
                        Visible
                      </label>
                      {conditions.isVisibleChecked && (
                        <div>
                          <label>
                            <input
                              type="checkbox"
                              checked={conditions.isVisibleIfChecked}
                              onChange={() =>
                                setConditions((prev) => {
                                  const isChecked = !prev.isVisibleIfChecked;
                                  return {
                                    ...prev,
                                    isVisibleIfChecked: isChecked,
                                    visibleFieldValue: isChecked ? [""] : [], // Initialize with 1 default field when checked
                                    visibleCondition: isChecked
                                      ? ["Equals"]
                                      : [],
                                    visibleConditionValue: isChecked
                                      ? [""]
                                      : [],
                                  };
                                })
                              }
                            />
                            Visible if
                          </label>
                          {conditions.isVisibleIfChecked && (
                            <>
                              {conditions.visibleFieldValue.map((_, index) => (
                                <div key={index} className="RegisterDiv">
                                  <div className="registration_edit_row">
                                    <InputLabel>Visible Field</InputLabel>
                                    <SelectBorder
                                      value={
                                        conditions.visibleFieldValue[index]
                                      }
                                      onChange={(e) =>
                                        handleConditionChange(
                                          e,
                                          index,
                                          "visibleFieldValue"
                                        )
                                      }
                                    >
                                      <option value="">Select Field</option>
                                      {formSchema.map((item, i) => (
                                        <option key={i} value={item.dataName}>
                                          {item.label.length > 60
                                            ? `${item.label.slice(0, 150)}...`
                                            : item.label}
                                        </option>
                                      ))}
                                    </SelectBorder>
                                  </div>
                                  <div className="registration_edit_row">
                                    <InputLabel>Condition</InputLabel>
                                    <SelectBorder
                                      value={conditions.visibleCondition[index]}
                                      onChange={(e) =>
                                        handleConditionChange(
                                          e,
                                          index,
                                          "visibleCondition"
                                        )
                                      }
                                    >
                                      <option value="Equals">
                                        Equals (Default)
                                      </option>
                                      <option value="contains">Contains</option>
                                      <option value="not-contains">
                                        Not Contains
                                      </option>
                                      <option value="startsWith">
                                        Starts With
                                      </option>
                                      <option value="not-startsWith">
                                        Not Starts With
                                      </option>
                                      <option value="endsWith">
                                        Ends With
                                      </option>
                                      <option value="not-endsWith">
                                        Not Ends With
                                      </option>
                                    </SelectBorder>
                                  </div>
                                  <div className="registration_edit_row">
                                    <InputLabel>Condition Value</InputLabel>
                                    <InputType
                                      type="text"
                                      value={
                                        conditions.visibleConditionValue[index]
                                      }
                                      onChange={(e) =>
                                        handleConditionChange(
                                          e,
                                          index,
                                          "visibleConditionValue"
                                        )
                                      }
                                    />
                                  </div>
                                  <div className="removeIcon">
                                    <RiDeleteBin4Fill
                                      className="remove-condition-icon"
                                      onClick={() =>
                                        removeVisibleConditionField(index)
                                      }
                                      style={{
                                        cursor: "pointer",
                                        color: "red",
                                        fontSize: "1.5em",
                                      }}
                                      title="Remove Condition"
                                    />
                                  </div>
                                </div>
                              ))}
                              <div className="registration_edit_row">
                                <InputLabel>Criteria Pattern</InputLabel>
                                <InputType
                                  type="text"
                                  value={conditions.visibleCriteriaPattern}
                                  onChange={(e) =>
                                    handleCriteriaPatternChange(
                                      e,
                                      "visibleCriteriaPattern"
                                    )
                                  }
                                  onBlur={() =>
                                    handleCriteriaPatternBlur(
                                      "visibleCriteriaPattern",
                                      conditions.visibleFieldValue.length
                                    )
                                  }
                                  placeholder="(1) AND (2)"
                                />
                                {errors.visibleCriteriaPattern && (
                                  <div className="error">
                                    {errors.visibleCriteriaPattern}
                                  </div>
                                )}
                                <div
                                  style={{
                                    marginTop: "0.5rem",
                                    display: "flex",
                                    gap: "0.5rem",
                                  }}
                                >
                                  <button
                                    type="button"
                                    className="conjunction-btn"
                                    onClick={() =>
                                      handleConjunctionChange("AND", "visible")
                                    }
                                    style={{
                                      padding: "0.5rem 1rem",
                                      backgroundColor:
                                        conditions.visibleCriteriaPattern.includes(
                                          "AND"
                                        )
                                          ? "#d32f2f"
                                          : "#e0e0e0",
                                      color:
                                        conditions.visibleCriteriaPattern.includes(
                                          "AND"
                                        )
                                          ? "#fff"
                                          : "#333",
                                      border: "1px solid #ccc",
                                      borderRadius: "4px",
                                      cursor: "pointer",
                                    }}
                                  >
                                    AND
                                  </button>
                                  <button
                                    type="button"
                                    className="conjunction-btn"
                                    onClick={() =>
                                      handleConjunctionChange("OR", "visible")
                                    }
                                    style={{
                                      padding: "0.5rem 1rem",
                                      backgroundColor:
                                        conditions.visibleCriteriaPattern.includes(
                                          "OR"
                                        )
                                          ? "#d32f2f"
                                          : "#e0e0e0",
                                      color:
                                        conditions.visibleCriteriaPattern.includes(
                                          "OR"
                                        )
                                          ? "#fff"
                                          : "#333",
                                      border: "1px solid #ccc",
                                      borderRadius: "4px",
                                      cursor: "pointer",
                                    }}
                                  >
                                    OR
                                  </button>
                                </div>
                              </div>
                              <button
                                type="button"
                                className="add-condition-btn"
                                onClick={addVisibleConditionField}
                                style={{ marginTop: "1rem" }}
                              >
                                <FaPlus className="plus-icon" /> Add Condition
                              </button>
                            </>
                          )}
                        </div>
                      )}
                    </div>

                    {/* Visible in Judging */}
                    <div className="visible-field">
                      <label>
                        <input
                          type="checkbox"
                          checked={
                           
                            conditions.isVisibleCheckedInJudging
                          }
                          onChange={() =>
                            setConditions((prev) => ({
                              ...prev,
                              isVisibleCheckedInJudging:
                                !prev.isVisibleCheckedInJudging,
                            }))
                          }
                        />
                        Visible In Judging
                      </label>
                      {conditions.isVisibleCheckedInJudging && (
                        <div>
                          <label>
                            <input
                              type="checkbox"
                              checked={conditions.isVisibleIfCheckedInJudging}
                              onChange={() =>
                                setConditions((prev) => {
                                  const isChecked =
                                    !prev.isVisibleIfCheckedInJudging;
                                  return {
                                    ...prev,
                                    isVisibleIfCheckedInJudging: isChecked,
                                    visibleInJudgingFieldValue: isChecked
                                      ? [""]
                                      : [], // Initialize with 1 default field when checked
                                    visibleInJudgingCondition: isChecked
                                      ? ["Equals"]
                                      : [],
                                    visibleInJudgingInConditionValue: isChecked
                                      ? [""]
                                      : [],
                                  };
                                })
                              }
                            />
                            Visible if in Judging
                          </label>
                          {conditions.isVisibleIfCheckedInJudging && (
                            <>
                              {conditions.visibleInJudgingFieldValue.map(
                                (_, index) => (
                                  <div key={index} className="RegisterDiv">
                                    <div className="registration_edit_row">
                                      <InputLabel>Visible Field</InputLabel>
                                      <SelectBorder
                                        value={
                                          conditions.visibleInJudgingFieldValue[
                                            index
                                          ]
                                        }
                                        onChange={(e) =>
                                          handleConditionChange(
                                            e,
                                            index,
                                            "visibleInJudgingFieldValue"
                                          )
                                        }
                                      >
                                        <option value="">Select Field</option>
                                        {formSchema.map((item, index) => (
                                          <option
                                            key={index}
                                            value={item.dataName}
                                          >
                                            {item.label.length > 60
                                              ? `${item.label.slice(0, 150)}...`
                                              : item.label}
                                          </option>
                                        ))}
                                      </SelectBorder>
                                    </div>
                                    <div className="registration_edit_row">
                                      <InputLabel>Condition</InputLabel>
                                      <SelectBorder
                                        value={
                                          conditions.visibleInJudgingCondition[
                                            index
                                          ]
                                        }
                                        onChange={(e) =>
                                          handleConditionChange(
                                            e,
                                            index,
                                            "visibleInJudgingCondition"
                                          )
                                        }
                                      >
                                        <option value="Equals">
                                          Equals (Default)
                                        </option>
                                        <option value="contains">
                                          Contains
                                        </option>
                                        <option value="not-contains">
                                          Not Contains
                                        </option>
                                        <option value="startsWith">
                                          Starts With
                                        </option>
                                        <option value="not-startsWith">
                                          Not Starts With
                                        </option>
                                        <option value="endsWith">
                                          Ends With
                                        </option>
                                        <option value="not-endsWith">
                                          Not Ends With
                                        </option>
                                      </SelectBorder>
                                    </div>
                                    <div className="registration_edit_row">
                                      <InputLabel>Condition Value</InputLabel>
                                      <InputType
                                        type="text"
                                        value={
                                          conditions
                                            .visibleInJudgingInConditionValue[
                                            index
                                          ] || ""
                                        }
                                        onChange={(e) =>
                                          handleConditionChange(
                                            e,
                                            index,
                                            "visibleInJudgingInConditionValue"
                                          )
                                        }
                                      />
                                    </div>
                                    <div className="removeIcon">
                                      <RiDeleteBin4Fill
                                        className="remove-condition-icon"
                                        onClick={() =>
                                          removeVisibleConditionFieldInJudging(
                                            index
                                          )
                                        }
                                        style={{
                                          cursor: "pointer",
                                          color: "red",
                                          fontSize: "1.5em",
                                        }}
                                        title="Remove Condition"
                                      />
                                    </div>
                                  </div>
                                )
                              )}
                              <div className="registration_edit_row">
                                <InputLabel>Criteria Pattern</InputLabel>
                                <InputType
                                  type="text"
                                  value={
                                    conditions.visibleInJudgingCriteriaPattern
                                  }
                                  onChange={(e) =>
                                    handleCriteriaPatternChange(
                                      e,
                                      "visibleInJudgingCriteriaPattern"
                                    )
                                  }
                                  onBlur={() =>
                                    handleCriteriaPatternBlur(
                                      "visibleInJudgingCriteriaPattern",
                                      conditions.visibleInJudgingFieldValue
                                        .length
                                    )
                                  }
                                  placeholder="(1) AND (2)"
                                />
                                {errors.visibleInJudgingCriteriaPattern && (
                                  <div className="error">
                                    {errors.visibleInJudgingCriteriaPattern}
                                  </div>
                                )}
                                <div
                                  style={{
                                    marginTop: "0.5rem",
                                    display: "flex",
                                    gap: "0.5rem",
                                  }}
                                >
                                  <button
                                    type="button"
                                    className="conjunction-btn"
                                    onClick={() =>
                                      handleConjunctionChange(
                                        "AND",
                                        "visibleInJudging"
                                      )
                                    }
                                    style={{
                                      padding: "0.5rem 1rem",
                                      backgroundColor:
                                        conditions.visibleInJudgingCriteriaPattern.includes(
                                          "AND"
                                        )
                                          ? "#d32f2f"
                                          : "#e0e0e0",
                                      color:
                                        conditions.visibleInJudgingCriteriaPattern.includes(
                                          "AND"
                                        )
                                          ? "#fff"
                                          : "#333",
                                      border: "1px solid #ccc",
                                      borderRadius: "4px",
                                      cursor: "pointer",
                                    }}
                                  >
                                    AND
                                  </button>
                                  <button
                                    type="button"
                                    className="conjunction-btn"
                                    onClick={() =>
                                      handleConjunctionChange(
                                        "OR",
                                        "visibleInJudging"
                                      )
                                    }
                                    style={{
                                      padding: "0.5rem 1rem",
                                      backgroundColor:
                                        conditions.visibleInJudgingCriteriaPattern.includes(
                                          "OR"
                                        )
                                          ? "#d32f2f"
                                          : "#e0e0e0",
                                      color:
                                        conditions.visibleInJudgingCriteriaPattern.includes(
                                          "OR"
                                        )
                                          ? "#fff"
                                          : "#333",
                                      border: "1px solid #ccc",
                                      borderRadius: "4px",
                                      cursor: "pointer",
                                    }}
                                  >
                                    OR
                                  </button>
                                </div>
                              </div>
                              <button
                                type="button"
                                className="add-condition-btn"
                                onClick={addVisibleInJudgingConditionField}
                                style={{ marginTop: "1rem" }}
                              >
                                <FaPlus className="plus-icon" /> Add Condition
                              </button>
                            </>
                          )}
                        </div>
                      )}
                    </div>
                  </>
                )}
            </form>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <GreyBorderButton onClick={onClose}>Cancel</GreyBorderButton>
        <RedBackgroundButton onClick={handleSave}>Save</RedBackgroundButton>
      </Modal.Footer>
    </Modal>
  );
};

export default EditFieldModal;
